import type { DiagnosticSeverity } from "../diagnostics/types";

import type { RepairProposal } from "./types";

const SEVERITY_WEIGHT: Record<DiagnosticSeverity, number> = {
  critical: 5,
  high: 4,
  medium: 3,
  low: 2,
  info: 1,
};

export function orderRepairProposals(
  proposals: readonly RepairProposal[],
): string[] {
  return [...proposals]
    .sort((a, b) => {
      const severity =
        SEVERITY_WEIGHT[b.severity] - SEVERITY_WEIGHT[a.severity];

      if (severity !== 0) {
        return severity;
      }

      if (a.requiresApproval !== b.requiresApproval) {
        return a.requiresApproval ? 1 : -1;
      }

      return a.id.localeCompare(b.id);
    })
    .map((proposal) => proposal.id);
}
